import { useProgress } from '@react-three/drei';

/**
 * 쇼룸 에셋 로딩 진행률 표시.
 *
 * useProgress는 three의 DefaultLoadingManager를 구독하는 zustand 스토어라서
 * Canvas 바깥(DOM)에서도 쓸 수 있습니다. 덕분에 차량 GLB와 HDRI를 포함한
 * 모든 로딩 진행률을 일반 HTML로 그릴 수 있고, 스크린 리더도 읽을 수 있습니다.
 */
export function ViewerLoadingOverlay() {
  const active = useProgress((state) => state.active);
  const progress = useProgress((state) => state.progress);
  if (!active) {
    return null;
  }
  const rounded = Math.round(progress);
  return (
    <div className="viewer-loading" role="status" aria-live="polite">
      <div
        className="viewer-loading__track"
        role="progressbar"
        aria-label="쇼룸 에셋 로딩 진행률"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={rounded}
      >
        <div className="viewer-loading__fill" style={{ width: `${rounded}%` }} />
      </div>
      <p className="viewer-loading__label">{`쇼룸 불러오는 중 ${rounded}%`}</p>
    </div>
  );
}
